
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28769",
  depVersions: {
  "payments-ui-app": "static-1.28769",
  "bend-plugin-arboretum": "static-1.2051",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.512",
  "crm_data": "static-4.93261",
  "data-fetching-client": "static-1.10141",
  "emoji-mart": "static-3.9",
  "enviro": "static-4.523",
  "foundations-components": "static-1.8791",
  "foundations-components-legacy": "static-1.1816",
  "head-dlb": "static-1.5330",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6094",
  "hs-test-utils": "static-1.8542",
  "hub-http": "static-1.6709",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11990",
  "I18n": "static-7.1715",
  "jasmine-runner": "static-1.6956",
  "quartz": "static-1.7694",
  "raven": "static-3.6411",
  "react-dlb": "static-1.96",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.123",
  "react-utils": "static-2.5681",
  "reselect": "static-3.18",
  "stripe-js": "static-1.122",
  "ui-components-test-utils": "static-1.6127",
  "UIComponents": "static-3.8936",
  "usage-tracker-public": "static-1.7636",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38102",
  "payments-checkout-lib": "static-1.692",
  "cssUtils": "static-1.1125",
  "customer-data-objects": "static-1.8214",
  "FireAlarmUi": "static-1.4893",
  "foundations-assets": "static-1.5392",
  "foundations-theming": "static-1.4993",
  "graphql": "static-1.95",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12297",
  "icons": "static-2.709",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3385",
  "property-translator": "static-1.5884",
  "quartz-config": "static-1.1472",
  "quartz-core": "static-1.6913",
  "quartz-i18n": "static-1.1369",
  "quartz-routing": "static-1.1124",
  "quartz-tracking": "static-1.1073",
  "react": "static-7.204",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17242",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "redux": "static-4.81",
  "redux-thunk": "static-2.86",
  "redux-toolkit": "static-1.84",
  "ReduxMessenger": "static-2.10873",
  "rpc-client-utils": "static-1.5169",
  "sanitize-text": "static-1.8661",
  "SharedI18nStrings": "static-1.190",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.520",
  "superstore": "static-1.5261",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11648",
  "ui-images": "static-2.1283",
  "usage-tracker-core": "static-1.7675",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3971",
  "quartz-webpack": "static-1.3918",
  "bend-plugin-quartz-routing": "static-1.772",
  "bender-build-tools": "static-1.3617",
  "crm_universal": "static-1.22764",
  "customer-data-email": "static-1.18682",
  "customer-data-ui-utilities": "static-1.10335",
  "dispatcher": "static-1.150",
  "frontend-preferences-client": "static-1.8424",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8265",
  "quick-fetch": "static-1.4245",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5060",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2709",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9931",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.111",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3158",
  "ui-fonts": "static-1.1252",
  "HeadJS": "static-2.829",
  "hs-test-utils-bend-plugin": "static-1.3653",
  "msw": "static-1.105",
  "msw-config": "static-1.35",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.416",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4809",
  "foundations-components-test-utils": "static-1.6274",
  "ui-addon-draggable": "static-3.5254",
  "commerce-billing-lib": "static-1.20541",
  "commerce-shared-components-lib": "static-1.19624",
  "commerce-tools-ui-lib": "static-1.11371",
  "crm-message-bus": "static-1.44161",
  "customer-data-objects-ui-components": "static-1.13539",
  "customer-data-properties": "static-1.53138",
  "growth-payments-core": "static-1.26550",
  "ui-addon-iframeable": "static-1.9582",
  "usage-tracker": "static-1.7825",
  "usage-tracker-container": "static-1.7815",
  "sassPrefix": "static-1.390",
  "inbound-db-properties-service-client": "static-1.4165",
  "foundations-theming-base": "static-1.3978",
  "bend-plugin-foundations-theming": "static-1.3476",
  "stylex": "static-1.48",
  "opentelemetry-fe-types": "static-1.295",
  "hub-http-janus": "static-1.913",
  "hubspotter-http": "static-1.4989",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.670",
  "quartz-auth": "static-1.1369",
  "quartz-head": "static-1.1359",
  "quartz-test": "static-1.1369",
  "trellis-components": "static-1.3177",
  "usage-tracker-session-replay": "static-1.5511",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.202",
  "web-vitals": "static-1.21",
  "immer": "static-1.107",
  "bend-plugin-chirp-manifest": "static-1.579",
  "chirp-fetch": "static-1.2408",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4973",
  "FormUrlGenerator": "static-2.5217",
  "sequences-lib": "static-1.8823",
  "apollo-link-hub-http": "static-2.5092",
  "FileManagerCore": "static-1.40384",
  "FileManagerLib": "static-1.40525",
  "hubspot-apollo-client": "static-1.5385",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.760",
  "timezone-utils": "static-2.5733",
  "ui-gdpr-components": "static-1.10658",
  "react-dnd-compat": "static-1.5111",
  "stylex-utils": "static-1.182",
  "trellis-theming": "static-1.1519",
  "react-flip-move": "static-1.85",
  "avatar-components": "static-1.2991",
  "hs-resources": "static-1.688",
  "pulse": "static-1.1154",
  "utility-belt": "static-1.3041",
  "zustand": "static-1.91",
  "batch-promise": "static-1.2053",
  "customer-data-associations": "static-1.7841",
  "customer-data-property-utils": "static-1.8556",
  "customer-data-tracking": "static-1.7375",
  "framework-data-schema-resolvers": "static-1.7396",
  "framework-data-table": "static-2.12883",
  "object-builder-ui-client": "static-1.50110",
  "payments-enrollment-embed-lib": "static-1.24287",
  "stripe-embedded-components": "static-1.8287",
  "ui-addon-opt": "static-4.8920",
  "ai-components-ui-library": "static-1.10070",
  "customer-data-rte": "static-1.33946",
  "cv-backend-services": "static-1.1611",
  "file-manager-components": "static-1.24885",
  "growth-onboarding-confetti": "static-1.3561",
  "growth-onboarding-empty-states": "static-1.6577",
  "hubspot-prosemirror": "static-1.19329",
  "InboxConnectUtils": "static-4.15888",
  "payment-link-components": "static-1.24511",
  "payments-post-enroll-local-storage-lib": "static-1.5609",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39214",
  "react-colorpicker": "static-2.10712",
  "ui-addon-upgrades": "static-9.18566",
  "ui-addon-video-player": "static-1.9126",
  "user-context": "static-1.5558",
  "restore-request-side-panel-lib": "static-1.2087",
  "atom": "static-1.5575",
  "reference-resolvers": "static-1.8687",
  "calling-global-api": "static-1.66278",
  "calling-internal-common": "static-1.31827",
  "calling-lifecycle-internal": "static-1.67660",
  "calling-lifecycle-messages": "static-1.59952",
  "commerce-products-lib": "static-1.10977",
  "conditional-properties-service-client": "static-1.4128",
  "crm-index-visualization-core": "static-1.4795",
  "crm-links": "static-1.6816",
  "crm-pipelines-api-client-types": "static-1.4458",
  "customer-data-properties-shared-msw-handlers": "static-1.10275",
  "data-agent-utils": "static-1.976",
  "data-token-picker": "static-1.17176",
  "external-options-client-types": "static-1.4453",
  "formula-editor": "static-1.15046",
  "google-libphonenumber": "static-1.52",
  "inbound-db-meta-service-client": "static-1.3789",
  "inbounddb-objects-service-types": "static-1.4529",
  "meetings-icalendar-utils-lib": "static-1.1135",
  "multi-currency-client-types": "static-1.4023",
  "pipeline-validation-client-types": "static-1.4298",
  "property-value-citations": "static-1.3752",
  "react-tinymce": "static-1.56317",
  "reference-resolvers-lite": "static-1.8617",
  "rich-text-lib": "static-1.20595",
  "smart-data-capture-core": "static-1.537",
  "tiered-pricing": "static-1.2327",
  "tinymce-config": "static-2.55443",
  "tinymce-plugins": "static-1.58557",
  "tinymce-themes": "static-1.57413",
  "topics-actions-lib": "static-1.688",
  "trellis-ext-i18n": "static-1.1427",
  "trial-components-library": "static-1.14429",
  "ui-addon-emoji-picker": "static-1.10367",
  "ui-addon-form-validation": "static-1.11352",
  "laboratory-lib": "static-3.7650",
  "onboarding-scopes": "static-1.6956",
  "seat-types-lib": "static-1.1097",
  "magpie-lib": "static-1.5932",
  "navigation-messaging": "static-1.8547",
  "ts-schema": "static-1.4409",
  "opentelemetry-web": "static-1.25",
  "hub-http-shared-msw-handlers": "static-1.10948",
  "hubspotter-http-shared-msw-handlers": "static-1.10946",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8680",
  "audio-components": "static-1.6610",
  "breeze-artifacts-sdk": "static-1.1077",
  "ContentUtils": "static-1.69536",
  "copilot-toolkit": "static-1.12200",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30100",
  "FileManagerImages": "static-1.38036",
  "html-to-image": "static-1.67",
  "immerable": "static-1.4646",
  "ui-universal-auth": "static-1.9794",
  "urlinator": "static-1.5017",
  "video-components": "static-1.14495",
  "video-data-lib": "static-1.36151",
  "video-embed": "static-1.36985",
  "hubspot-apollo-cache": "static-1.844",
  "trellis-migration-context": "static-1.81",
  "event-emitter": "static-1.1464",
  "fdsr-migration-layer": "static-1.515",
  "framework-builder-read-service-client": "static-1.4350",
  "bend-plugin-pulse": "static-1.657",
  "fast-json-patch": "static-1.76",
  "framework-data-schema-quick-fetch": "static-1.7301",
  "persist-promise": "static-1.4210",
  "customer-data-reference-ui-components": "static-1.13678",
  "reporting-data": "static-1.69463",
  "tasks-actions-lib": "static-1.485",
  "purchase-motions-components": "static-1.6668",
  "growth-onboarding-feedback-components": "static-1.7084",
  "growth-onboarding-reliability": "static-1.5587",
  "marketplace-ui-apps-core": "static-1.19609",
  "onboarding-tours": "static-1.17428",
  "stripe-connect-js": "static-1.85",
  "chatspot-core": "static-1.24039",
  "content-assistance-lib": "static-1.8460",
  "draft-content-plugins": "static-1.29199",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22399",
  "breeze-engine-lib": "static-1.2266",
  "poll-commands": "static-1.3980",
  "video-components-external": "static-1.12493",
  "trellis-story-utils": "static-1.5002",
  "ui-addon-react-router-dom": "static-1.10028",
  "content-media-capture": "static-1.5837",
  "knowledge-content-types": "static-1.8767",
  "ui-business-units-lib": "static-1.9600",
  "ui-shepherd-react": "static-3.10784",
  "hub-http-contrib": "static-1.3535",
  "ui-addon-sales-email": "static-1.5706",
  "commerce-tours-lib": "static-1.6901",
  "getting-started-shared-tasks": "static-1.19611",
  "sales-checkout-service-client": "static-1.4025",
  "merchandise-lib": "static-1.288",
  "getting-started-shared-tasks-store": "static-1.18729",
  "onboarding-tours-utils": "static-1.1495",
  "calling-error-reporting": "static-1.31834",
  "shared-worker-versioning": "static-1.11546",
  "calling-usage-tracker": "static-1.7044",
  "conversations-skeleton-state": "static-1.7621",
  "voice-sms-access-library": "static-1.2534",
  "commerce-permissions": "static-1.1290",
  "products-iframe-lib": "static-1.8966",
  "products-ui-components-shared-msw-handlers": "static-1.11330",
  "crm-index-associations-lib": "static-1.6952",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11031",
  "sales-views-client-types": "static-1.4761",
  "location-customization-utils-lib": "static-1.10473",
  "data-agent-kit": "static-1.963",
  "enrichment-settings-lib": "static-1.301",
  "fsm": "static-1.4260",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7308",
  "bark-lib": "static-1.17037",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6401",
  "react-codemirror": "static-1.11146",
  "tinymce": "static-5.11",
  "interframe": "static-3.5246",
  "tinymce-data": "static-1.41528",
  "layout-dnd-components": "static-1.13267",
  "layout-dnd-utils": "static-1.12242",
  "ui-brand-identity-lib": "static-1.17012",
  "NamespacedHubStyle": "static-2.9382",
  "embedded-academy-lib": "static-1.16088",
  "hubs-service-types": "static-1.1770",
  "navigation-components": "static-1.19220",
  "nest": "static-1.740",
  "nudge-client-utils": "static-1.3461",
  "purchase-motions-api": "static-1.6671",
  "signup-constants": "static-1.19994",
  "idb-keyval": "static-1.57",
  "magpie-types": "static-1.5392",
  "reactive-lib": "static-1.1223",
  "simple-logging-lib": "static-1.3554",
  "nav-meta": "static-1.30857",
  "breeze-engine-core": "static-1.1544",
  "cms-field-types": "static-1.5314",
  "content-icons-ui": "static-1.2484",
  "integrations-lib": "static-1.17486",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.358",
  "unified-auth-core-lib": "static-1.1590",
  "social-insights-client-types": "static-1.22976",
  "outpost": "static-1.4633",
  "reporting-client-types": "static-1.2862",
  "signup-ui-url-generator": "static-2.8541",
  "developer-experience-shared-components": "static-1.11045",
  "immutable-less": "static-1.5154",
  "marketplace-ui-client-types": "static-1.18484",
  "marketplace-ui-common": "static-1.21077",
  "ui-addon-integrations-directory-panel": "static-2.8457",
  "ui-extensibility-client-types": "static-1.4418",
  "growth-data-modal": "static-1.6170",
  "growth-onboarding-next-action-utils": "static-1.3032",
  "onboarding-tours-client": "static-1.5643",
  "ui-shepherd-tracker": "static-1.8165",
  "ui-coaching-tips": "static-1.29612",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1244",
  "highlight.js": "static-1.92",
  "content-media-composition-data-lib": "static-1.13641",
  "content-media-compositions": "static-2.17648",
  "media-bridge-lib": "static-1.19680",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4933",
  "calling-orchestration-schema": "static-1.37311",
  "crm-record-cards-service-types": "static-1.3876",
  "highcharts": "static-8.117",
  "storybook-react": "static-1.46",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16714",
  "browser-eslint": "static-2.57",
  "ContentData": "static-1.69611",
  "layout-data-lib": "static-1.10567",
  "academy-common-lib": "static-1.15549",
  "nudge-custom-function-registry": "static-1.3218",
  "nudge-renderer-utils": "static-1.3537",
  "whisper-core-api": "static-1.7675",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14901",
  "integrations-tracking-lib": "static-1.6126",
  "redux-observable": "static-1.81",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4113",
  "oauth-service-types": "static-1.4639",
  "ai-settings-ui-library": "static-1.8633",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1673",
  "onboarding-data-sync-lib": "static-1.2875",
  "growth-onboarding-next-action-components": "static-1.3060",
  "user-context-client": "static-1.5012",
  "js-cookie": "static-1.18",
  "advanced-menus-core": "static-1.15859",
  "advanced-menus-lib": "static-1.12602",
  "ExportDialog": "static-6.10876",
  "ui-memberships-settings-lib": "static-1.35253",
  "academy-service-client": "static-1.4195",
  "croppie": "static-2.10",
  "final-form": "static-1.85",
  "SafeStorage": "static-1.4898",
  "trellis-ecosystem": "static-1.7891",
  "wootric-nps": "static-1.7312",
  "universal-page-editor-lib": "static-1.3516",
  "settings-ui-lib": "static-1.13031",
  "simple-data-table": "static-1.3866",
  "meetings-connect-utils-lib": "static-1.8123",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15858",
  "simple-menus-lib": "static-1.17375",
  "crm-record-cards-client": "static-1.118"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28769",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2051",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.512",
  "crm_data": "/crm_data/static-4.93261",
  "data-fetching-client": "/data-fetching-client/static-1.10141",
  "emoji-mart": "/emoji-mart/static-3.9",
  "enviro": "/enviro/static-4.523",
  "foundations-components": "/foundations-components/static-1.8791",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1816",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6094",
  "hs-test-utils": "/hs-test-utils/static-1.8542",
  "hub-http": "/hub-http/static-1.6709",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11990",
  "I18n": "/I18n/static-7.1715",
  "jasmine-runner": "/jasmine-runner/static-1.6956",
  "quartz": "/quartz/static-1.7694",
  "raven": "/raven/static-3.6411",
  "react-dlb": "/react-dlb/static-1.96",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.123",
  "react-utils": "/react-utils/static-2.5681",
  "reselect": "/reselect/static-3.18",
  "stripe-js": "/stripe-js/static-1.122",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6127",
  "UIComponents": "/UIComponents/static-3.8936",
  "usage-tracker-public": "/usage-tracker-public/static-1.7636",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38102",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.692",
  "cssUtils": "/cssUtils/static-1.1125",
  "customer-data-objects": "/customer-data-objects/static-1.8214",
  "FireAlarmUi": "/FireAlarmUi/static-1.4893",
  "foundations-assets": "/foundations-assets/static-1.5392",
  "foundations-theming": "/foundations-theming/static-1.4993",
  "graphql": "/graphql/static-1.95",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12297",
  "icons": "/icons/static-2.709",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3385",
  "property-translator": "/property-translator/static-1.5884",
  "quartz-config": "/quartz-config/static-1.1472",
  "quartz-core": "/quartz-core/static-1.6913",
  "quartz-i18n": "/quartz-i18n/static-1.1369",
  "quartz-routing": "/quartz-routing/static-1.1124",
  "quartz-tracking": "/quartz-tracking/static-1.1073",
  "react": "/react/static-7.204",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17242",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.86",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "ReduxMessenger": "/ReduxMessenger/static-2.10873",
  "rpc-client-utils": "/rpc-client-utils/static-1.5169",
  "sanitize-text": "/sanitize-text/static-1.8661",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "superstore": "/superstore/static-1.5261",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11648",
  "ui-images": "/ui-images/static-2.1283",
  "usage-tracker-core": "/usage-tracker-core/static-1.7675",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3971",
  "quartz-webpack": "/quartz-webpack/static-1.3918",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.772",
  "bender-build-tools": "/bender-build-tools/static-1.3617",
  "crm_universal": "/crm_universal/static-1.22764",
  "customer-data-email": "/customer-data-email/static-1.18682",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10335",
  "dispatcher": "/dispatcher/static-1.150",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8424",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8265",
  "quick-fetch": "/quick-fetch/static-1.4245",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5060",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2709",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9931",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.111",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3158",
  "ui-fonts": "/ui-fonts/static-1.1252",
  "HeadJS": "/HeadJS/static-2.829",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3653",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.35",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.416",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4809",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6274",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5254",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20541",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19624",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11371",
  "crm-message-bus": "/crm-message-bus/static-1.44161",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13539",
  "customer-data-properties": "/customer-data-properties/static-1.53138",
  "growth-payments-core": "/growth-payments-core/static-1.26550",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9582",
  "usage-tracker": "/usage-tracker/static-1.7825",
  "usage-tracker-container": "/usage-tracker-container/static-1.7815",
  "sassPrefix": "/sassPrefix/static-1.390",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4165",
  "foundations-theming-base": "/foundations-theming-base/static-1.3978",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3476",
  "stylex": "/stylex/static-1.48",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.295",
  "hub-http-janus": "/hub-http-janus/static-1.913",
  "hubspotter-http": "/hubspotter-http/static-1.4989",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.670",
  "quartz-auth": "/quartz-auth/static-1.1369",
  "quartz-head": "/quartz-head/static-1.1359",
  "quartz-test": "/quartz-test/static-1.1369",
  "trellis-components": "/trellis-components/static-1.3177",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5511",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.202",
  "web-vitals": "/web-vitals/static-1.21",
  "immer": "/immer/static-1.107",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.579",
  "chirp-fetch": "/chirp-fetch/static-1.2408",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4973",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5217",
  "sequences-lib": "/sequences-lib/static-1.8823",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5092",
  "FileManagerCore": "/FileManagerCore/static-1.40384",
  "FileManagerLib": "/FileManagerLib/static-1.40525",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5385",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.760",
  "timezone-utils": "/timezone-utils/static-2.5733",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "react-dnd-compat": "/react-dnd-compat/static-1.5111",
  "stylex-utils": "/stylex-utils/static-1.182",
  "trellis-theming": "/trellis-theming/static-1.1519",
  "react-flip-move": "/react-flip-move/static-1.85",
  "avatar-components": "/avatar-components/static-1.2991",
  "hs-resources": "/hs-resources/static-1.688",
  "pulse": "/pulse/static-1.1154",
  "utility-belt": "/utility-belt/static-1.3041",
  "zustand": "/zustand/static-1.91",
  "batch-promise": "/batch-promise/static-1.2053",
  "customer-data-associations": "/customer-data-associations/static-1.7841",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8556",
  "customer-data-tracking": "/customer-data-tracking/static-1.7375",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7396",
  "framework-data-table": "/framework-data-table/static-2.12883",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50110",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24287",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8287",
  "ui-addon-opt": "/ui-addon-opt/static-4.8920",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10070",
  "customer-data-rte": "/customer-data-rte/static-1.33946",
  "cv-backend-services": "/cv-backend-services/static-1.1611",
  "file-manager-components": "/file-manager-components/static-1.24885",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3561",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6577",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19329",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15888",
  "payment-link-components": "/payment-link-components/static-1.24511",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5609",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39214",
  "react-colorpicker": "/react-colorpicker/static-2.10712",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18566",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9126",
  "user-context": "/user-context/static-1.5558",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2087",
  "atom": "/atom/static-1.5575",
  "reference-resolvers": "/reference-resolvers/static-1.8687",
  "calling-global-api": "/calling-global-api/static-1.66278",
  "calling-internal-common": "/calling-internal-common/static-1.31827",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67660",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59952",
  "commerce-products-lib": "/commerce-products-lib/static-1.10977",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4128",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4795",
  "crm-links": "/crm-links/static-1.6816",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4458",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10275",
  "data-agent-utils": "/data-agent-utils/static-1.976",
  "data-token-picker": "/data-token-picker/static-1.17176",
  "external-options-client-types": "/external-options-client-types/static-1.4453",
  "formula-editor": "/formula-editor/static-1.15046",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3789",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4529",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1135",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4023",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4298",
  "property-value-citations": "/property-value-citations/static-1.3752",
  "react-tinymce": "/react-tinymce/static-1.56317",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8617",
  "rich-text-lib": "/rich-text-lib/static-1.20595",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.537",
  "tiered-pricing": "/tiered-pricing/static-1.2327",
  "tinymce-config": "/tinymce-config/static-2.55443",
  "tinymce-plugins": "/tinymce-plugins/static-1.58557",
  "tinymce-themes": "/tinymce-themes/static-1.57413",
  "topics-actions-lib": "/topics-actions-lib/static-1.688",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1427",
  "trial-components-library": "/trial-components-library/static-1.14429",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10367",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "laboratory-lib": "/laboratory-lib/static-3.7650",
  "onboarding-scopes": "/onboarding-scopes/static-1.6956",
  "seat-types-lib": "/seat-types-lib/static-1.1097",
  "magpie-lib": "/magpie-lib/static-1.5932",
  "navigation-messaging": "/navigation-messaging/static-1.8547",
  "ts-schema": "/ts-schema/static-1.4409",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10948",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10946",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8680",
  "audio-components": "/audio-components/static-1.6610",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1077",
  "ContentUtils": "/ContentUtils/static-1.69536",
  "copilot-toolkit": "/copilot-toolkit/static-1.12200",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30100",
  "FileManagerImages": "/FileManagerImages/static-1.38036",
  "html-to-image": "/html-to-image/static-1.67",
  "immerable": "/immerable/static-1.4646",
  "ui-universal-auth": "/ui-universal-auth/static-1.9794",
  "urlinator": "/urlinator/static-1.5017",
  "video-components": "/video-components/static-1.14495",
  "video-data-lib": "/video-data-lib/static-1.36151",
  "video-embed": "/video-embed/static-1.36985",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.844",
  "trellis-migration-context": "/trellis-migration-context/static-1.81",
  "event-emitter": "/event-emitter/static-1.1464",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.515",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4350",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.657",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7301",
  "persist-promise": "/persist-promise/static-1.4210",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13678",
  "reporting-data": "/reporting-data/static-1.69463",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.485",
  "purchase-motions-components": "/purchase-motions-components/static-1.6668",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7084",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5587",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19609",
  "onboarding-tours": "/onboarding-tours/static-1.17428",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "chatspot-core": "/chatspot-core/static-1.24039",
  "content-assistance-lib": "/content-assistance-lib/static-1.8460",
  "draft-content-plugins": "/draft-content-plugins/static-1.29199",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22399",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2266",
  "poll-commands": "/poll-commands/static-1.3980",
  "video-components-external": "/video-components-external/static-1.12493",
  "trellis-story-utils": "/trellis-story-utils/static-1.5002",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10028",
  "content-media-capture": "/content-media-capture/static-1.5837",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9600",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10784",
  "hub-http-contrib": "/hub-http-contrib/static-1.3535",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5706",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6901",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19611",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4025",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18729",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1495",
  "calling-error-reporting": "/calling-error-reporting/static-1.31834",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11546",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7044",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7621",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2534",
  "commerce-permissions": "/commerce-permissions/static-1.1290",
  "products-iframe-lib": "/products-iframe-lib/static-1.8966",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11330",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6952",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11031",
  "sales-views-client-types": "/sales-views-client-types/static-1.4761",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10473",
  "data-agent-kit": "/data-agent-kit/static-1.963",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.301",
  "fsm": "/fsm/static-1.4260",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7308",
  "bark-lib": "/bark-lib/static-1.17037",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6401",
  "react-codemirror": "/react-codemirror/static-1.11146",
  "tinymce": "/tinymce/static-5.11",
  "interframe": "/interframe/static-3.5246",
  "tinymce-data": "/tinymce-data/static-1.41528",
  "layout-dnd-components": "/layout-dnd-components/static-1.13267",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12242",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17012",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9382",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16088",
  "hubs-service-types": "/hubs-service-types/static-1.1770",
  "navigation-components": "/navigation-components/static-1.19220",
  "nest": "/nest/static-1.740",
  "nudge-client-utils": "/nudge-client-utils/static-1.3461",
  "purchase-motions-api": "/purchase-motions-api/static-1.6671",
  "signup-constants": "/signup-constants/static-1.19994",
  "idb-keyval": "/idb-keyval/static-1.57",
  "magpie-types": "/magpie-types/static-1.5392",
  "reactive-lib": "/reactive-lib/static-1.1223",
  "simple-logging-lib": "/simple-logging-lib/static-1.3554",
  "nav-meta": "/nav-meta/static-1.30857",
  "breeze-engine-core": "/breeze-engine-core/static-1.1544",
  "cms-field-types": "/cms-field-types/static-1.5314",
  "content-icons-ui": "/content-icons-ui/static-1.2484",
  "integrations-lib": "/integrations-lib/static-1.17486",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.358",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1590",
  "social-insights-client-types": "/social-insights-client-types/static-1.22976",
  "outpost": "/outpost/static-1.4633",
  "reporting-client-types": "/reporting-client-types/static-1.2862",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8541",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11045",
  "immutable-less": "/immutable-less/static-1.5154",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18484",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21077",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8457",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4418",
  "growth-data-modal": "/growth-data-modal/static-1.6170",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3032",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5643",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8165",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29612",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1244",
  "highlight.js": "/highlight.js/static-1.92",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13641",
  "content-media-compositions": "/content-media-compositions/static-2.17648",
  "media-bridge-lib": "/media-bridge-lib/static-1.19680",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4933",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37311",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3876",
  "highcharts": "/highcharts/static-8.117",
  "storybook-react": "/storybook-react/static-1.46",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16714",
  "browser-eslint": "/browser-eslint/static-2.57",
  "ContentData": "/ContentData/static-1.69611",
  "layout-data-lib": "/layout-data-lib/static-1.10567",
  "academy-common-lib": "/academy-common-lib/static-1.15549",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3218",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3537",
  "whisper-core-api": "/whisper-core-api/static-1.7675",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14901",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6126",
  "redux-observable": "/redux-observable/static-1.81",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4113",
  "oauth-service-types": "/oauth-service-types/static-1.4639",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8633",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1673",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2875",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3060",
  "user-context-client": "/user-context-client/static-1.5012",
  "js-cookie": "/js-cookie/static-1.18",
  "advanced-menus-core": "/advanced-menus-core/static-1.15859",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12602",
  "ExportDialog": "/ExportDialog/static-6.10876",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35253",
  "academy-service-client": "/academy-service-client/static-1.4195",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.85",
  "SafeStorage": "/SafeStorage/static-1.4898",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7891",
  "wootric-nps": "/wootric-nps/static-1.7312",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3516",
  "settings-ui-lib": "/settings-ui-lib/static-1.13031",
  "simple-data-table": "/simple-data-table/static-1.3866",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8123",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15858",
  "simple-menus-lib": "/simple-menus-lib/static-1.17375",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.118"
}
};
